"use strict";
/*
 * © 2025 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.writeText = writeText;
function unsecuredCopyToClipboard(text) {
    let htmlElement = undefined;
    try {
        htmlElement = document.createElement("textarea");
        htmlElement.value = text;
        document.body.appendChild(htmlElement);
        htmlElement.focus();
        htmlElement.select();
        document.execCommand("copy");
    }
    catch (err) {
        console.error("Unable to copy to clipboard", err);
        console.log(text);
    }
    finally {
        if (htmlElement)
            document.body.removeChild(htmlElement);
    }
}
function writeText(text) {
    if (window.isSecureContext) {
        navigator.clipboard.writeText(text);
    }
    else {
        unsecuredCopyToClipboard(text);
    }
}
//# sourceMappingURL=index.js.map